<template>
  <BaseList
    document-type="notifications"
    :show-modal-button="false"
    list-type="toggle"
    meta-name="Notifications"
    path="/app/settings/notifications"
    api-items-field="notificationFields"
    :list-field-names="{ main: '', status: '', toggleModel: 'enabled' }"
    :toggle-actions="{ active: 'on', inactive: 'off' }"
    :api-names="{
      load: 'settingsGetNotifications',
      post: 'settingsUpdateNotifications',
    }"
  />
</template>

<script>
import BaseList from './components/lists/BaseList.vue';

export default {
  name: 'NotificationsList',
  components: {
    BaseList,
  },
};
</script>
